// Zoom range slider pre-defined marks

export const ZOOM_RANGE_SLIDER_MARKS = 
[
  {
    value: 1,
    scaledValue: 100,
    label: "1:100"
  },
  {
    value: 2,
    scaledValue: 250,
    label: "1:250"
  },
  {
    value: 3,
    scaledValue: 500,
    label: "1:500"
  },
  {
    value: 4,
    scaledValue: 1000,
    label: "1:1,000"
  },
  {
    value: 5,
    scaledValue: 2000,
    label: "1:2,000"
  },
  {
    value: 6,
    scaledValue: 3500,
    label: "1:3,500"
  },
  {
    value: 7,
    scaledValue: 7000,
    label: "1:7,000"
  },
  {
    value: 8,
    scaledValue: 13000,
    label: "1:13,000"
  },
  {
    value: 9,
    scaledValue: 25000,
    label: "1:25,000"
  },
  {
    value: 10,
    scaledValue: 50000,
    label: "1:50,000"
  },
  {
    value: 11,
    scaledValue: 100000,
    label: "1:100,000"
  },
  {
    value: 12,
    scaledValue: 175000,
    label: "1:175,000"
  },
  {
    value: 13,
    scaledValue: 300000,
    label: "1:300,000"
  },
  {
    value: 14,
    scaledValue: 600000,
    label: "1:600,000"
  },
  {
    value: 15,
    scaledValue: 1000000,
    label: "1:1 million"
  },
  {
    value: 16,
    scaledValue: 2000000,
    label: "1:2 million"
  },
  {
    value: 17,
    scaledValue: 4000000,
    label: "1:4 million"
  },
  {
    value: 18,
    scaledValue: 8000000,
    label: "1:8 million"
  },
  {
    value: 19,
    scaledValue: 15000000,
    label: "1:15 million"
  },
  {
    value: 20,
    scaledValue: 30000000,
    label: "1:30 million"
  },
];